import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormInputDropdown } from '../form/FormInputDropdown';
import Delete from '@mui/icons-material/Delete';
const permission = [
  {
    value: 'READ',
    label: 'READ',
  },
  {
    value: 'WRITE',
    label: 'WRITE',
  },
];
const SelectStyle = {
  bgcolor: 'white',
  width: '135px',
  borderRadius: '6px',
  '&.Mui-disabled': {
    bgcolor: 'black', // Customize your disabled background color
    color: 'grey', // Customize your disabled text color
  },
};

const MenuSelect = ({ control, menuData, index, data, remove }) => {
  const { t } = useTranslation();
  const [mainMenu, setMainMenu] = useState(null);
  const [subMenu, setSubMenu] = useState(null);

  const handleSubMenu = selectedId => {
    // filter from menudata where item.menuId equalst selectedId and return its subMenus
    const filteredSubMenus = menuData
      .filter(item => item.menuId === selectedId)[0]
      .subMenus.map(j => {
        return {
          value: j.menuId,
          label: t(j.name),
        };
      });

    setSubMenu(filteredSubMenus.length > 0 ? filteredSubMenus : null);
  };

  const handleDelete = () => {
    remove(index);
  };

  useEffect(() => {
    if (menuData) {
      const filter = menuData.map(i => {
        return {
          value: i.menuId,
          label: t(i.name),
        };
      });
      setMainMenu(filter);
    }
  }, [menuData]);

  useEffect(() => {
    if (data?.parentId) {
      handleSubMenu(data.parentId);
    }
  }, [data]);

  return (
    <Box
      sx={{
        bgcolor: '#fafbfc',
        padding: '10px 20px ',
        display: 'flex',
        alignItems: 'center',
      }}>
      <Typography sx={{ fontSize: '14px', mr: '18px' }}>{t('Main Menu')}</Typography>
      {mainMenu != null && (
        <FormInputDropdown
          name={`representativeMenus.${index}.parentId`}
          rules={{ required: true }}
          sx={SelectStyle}
          control={control}
          onChange={e => handleSubMenu(e.target.value)}
          options={mainMenu}
        />
      )}
      <Typography sx={{ fontSize: '14px', ml: '30px', mr: '18px' }}>{t('Sub Menu')}</Typography>

      <FormInputDropdown
        name={`representativeMenus.${index}.menuId`}
        disabled={!subMenu}
        rules={{ required: subMenu !== null }}
        sx={SelectStyle}
        control={control}
        options={subMenu}
      />
      <Typography sx={{ fontSize: '14px', ml: '30px', mr: '18px' }}>{t('Permission')}</Typography>
      <FormInputDropdown
        name={`representativeMenus.${index}.accessType`}
        sx={SelectStyle}
        rules={{ required: true }}
        control={control}
        options={permission}
      />
      <Delete
        onClick={handleDelete}
        sx={{
          ml: 'auto',
        }}
      />
    </Box>
  );
};

export default MenuSelect;
